<h1 class="pb-2 border-bottom fw-light" i18n>E-Mail-Warteschlange</h1>

<p class="text-muted mt-2" i18n>
  Alle vom Portal versendeten E-Mails (Registrierung, Passwort, Löschbestätigung). Eine
  E-Mail wird nach dem Anfordern im Hintergrund zugestellt; schlägt die Zustellung mehrfach
  fehl, bleibt sie als „Fehlgeschlagen“ stehen und kann hier erneut gesendet werden. Der
  Inhalt einer E-Mail wird aus Datenschutzgründen nicht angezeigt.
</p>

<div class="row g-2 align-items-end border rounded p-3 mb-3 bg-light">
  <div class="col-sm-2">
    <label class="form-label col-form-label-sm mb-0" i18n>Status</label>
    <kendo-dropdownlist
      [data]="statusItems"
      [value]="filter.status"
      textField="label"
      valueField="value"
      [valuePrimitive]="true"
      [defaultItem]="{ value: null, label: allStatusesLabel }"
      (valueChange)="onStatusChange($event)"
    ></kendo-dropdownlist>
  </div>
  <div class="col-sm-3">
    <label class="form-label col-form-label-sm mb-0" for="emailQueueRecipient" i18n>Empfänger</label>
    <input
      id="emailQueueRecipient"
      type="text"
      class="form-control form-control-sm"
      [(ngModel)]="filter.recipient"
      (keyup.enter)="search()"
      i18n-placeholder
      placeholder="Enthält …"
    />
  </div>
  <div class="col-sm-2">
    <label class="form-label col-form-label-sm mb-0" for="emailQueueTemplate" i18n>Vorlage</label>
    <input
      id="emailQueueTemplate"
      type="text"
      class="form-control form-control-sm"
      [(ngModel)]="filter.templateKey"
      (keyup.enter)="search()"
    />
  </div>
  <div class="col-sm-3">
    <label class="form-label col-form-label-sm mb-0" for="emailQueueCorrelation" i18n>Referenz</label>
    <input
      id="emailQueueCorrelation"
      type="text"
      class="form-control form-control-sm"
      [(ngModel)]="filter.correlationId"
      (keyup.enter)="search()"
    />
  </div>
  <div class="col-sm-2 text-end">
    <button class="btn btn-primary btn-sm me-1" type="button" (click)="search()" i18n>Suchen</button>
    <button class="btn btn-secondary btn-sm" type="button" (click)="reload()" i18n>Aktualisieren</button>
  </div>
</div>

<kendo-grid
  [data]="list.gridData"
  [pageable]="true"
  [skip]="list.state.skip"
  [pageSize]="list.state.pageSize"
  [sortable]="true"
  [sort]="list.state.sort"
  (pageChange)="list.onPageChange($event)"
  (sortChange)="list.onSortChange($event)"
  [resizable]="true"
>
  <ng-template kendoGridNoRecordsTemplate>
    <app-grid-no-records [loading]="list.loading" loadingText="E-Mails werden geladen…" i18n-loadingText emptyText="Keine E-Mails vorhanden" i18n-emptyText></app-grid-no-records>
  </ng-template>

  <kendo-grid-column field="createdAt" i18n-title title="Angefordert" [width]="150">
    <ng-template kendoGridCellTemplate let-dataItem>
      {{ dataItem.createdAtDate | date: 'short' }}
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="status" i18n-title title="Status" [width]="130">
    <ng-template kendoGridCellTemplate let-dataItem>
      <span class="badge" [ngClass]="statusClass(dataItem.status)">{{ statusName(dataItem.status) }}</span>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="recipientEmail" i18n-title title="Empfänger" [width]="220"></kendo-grid-column>

  <kendo-grid-column field="templateKey" i18n-title title="Vorlage" [width]="200"></kendo-grid-column>

  <kendo-grid-column field="subject" [sortable]="false" i18n-title title="Betreff"></kendo-grid-column>

  <kendo-grid-column field="attemptCount" i18n-title title="Versuche" [width]="90" class="text-end">
    <ng-template kendoGridCellTemplate let-dataItem>
      <span [title]="dataItem.nextAttemptAtDate ? (dataItem.nextAttemptAtDate | date: 'short') : ''">
        {{ dataItem.attemptCount }}
      </span>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="sentAt" i18n-title title="Gesendet" [width]="150">
    <ng-template kendoGridCellTemplate let-dataItem>
      {{ dataItem.sentAtDate ? (dataItem.sentAtDate | date: 'short') : '' }}
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="lastError" [sortable]="false" i18n-title title="Letzter Fehler" [width]="260">
    <ng-template kendoGridCellTemplate let-dataItem>
      <span class="email-queue__error" [title]="dataItem.lastError ?? ''">{{ dataItem.lastError }}</span>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="correlationId" [sortable]="false" i18n-title title="Referenz" [width]="160">
    <ng-template kendoGridCellTemplate let-dataItem>
      <span [title]="dataItem.requestedBy ?? ''">{{ dataItem.correlationId }}</span>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-command-column i18n-title title="" [width]="70">
    <ng-template kendoGridCellTemplate let-dataItem>
      @if (canRetry(dataItem)) {
        <button
          kendoGridEditCommand
          type="button"
          i18n-title
          title="Erneut senden"
          [asyncClick]="onRetry(dataItem)"
          [disabled]="retryBtn.disabled"
          #retryBtn="asyncClick"
        >
          <i>
            @if (retryBtn.busy) {
              <span class="spinner-border spinner-border-sm"></span>
            } @else {
              <fa-icon [icon]="faRedo"></fa-icon>
            }
          </i>
        </button>
      }
    </ng-template>
  </kendo-grid-command-column>
</kendo-grid>
